// @flow
import React, { Component } from 'react';
import { Link } from 'react-router';

import { LUX_TYPES, TYPE_LINKS } from './constants';

type Props = {
  name: string;
  version: string;
};

class Type extends Component<Props, Props, void> {
  static defaultProps = {
    name: '',
    version: 'latest'
  };

  render() {
    const { props: { version } } = this;
    let { props: { name } } = this;
    let key = name.replace(/^\?(.+)$/, '$1');
    let content = () => name;

    if (/^void$/i.test(key)) {
      key = 'undefined';
      name = name.toLowerCase();
    }

    if (TYPE_LINKS.has(key)) {
      content = () => (
        <a
          alt={name}
          href={TYPE_LINKS.get(key)}
          rel="noopener noreferrer"
          target="_blank"
        >
          {name}
        </a>
      );
    } else if (LUX_TYPES.has(key)) {
      content = () => (
        <Link to={`/docs/${version}/api/${key.toLowerCase()}`}>
          {name}
        </Link>
      );
    }

    return <span>{content()}</span>;
  }
}

export default Type;



// WEBPACK FOOTER //
// ./src/components/Type/index.jsx